// extracted by mini-css-extract-plugin
export default {"varCorrect":"VarItemCorrect_varCorrect__Vu261","varNumberCorrect":"VarItemCorrect_varNumberCorrect__d87al","varTitleCorrect":"VarItemCorrect_varTitleCorrect__+iriV"};